export const _getHeader_SP = (selected, deductions) => {
  const { payrollType, jobType, payItem, startDate, endDate } = selected;
  const { incentives } = deductions;

  const additionalHeader =
    incentives?.[0]?.otherAdditionals?.map((allowance) => ({
      label: allowance?.name,
    })) || [];

  const deductionHeader =
    incentives?.[0]?.otherDeductions?.map((deduction) => ({
      label: deduction?.name,
    })) || [];

  const allowanceName = payrollType === "Special Payroll" ? payItem : "";

  const commonHeaders = [
    { label: "Employee Number" },
    {
      label: jobType === "Job Order" ? "ACCOUNT NUMBER" : "ACCT NO.",
    },
    { label: "LAST NAME" },
    { label: "FIRST NAME" },
    { label: "MIDDLE NAME" },
  ];

  const earnedPeriodHeader = (month) => ({
    // Keep base label for convertLabels → earnedForThePeriod / earnedForThePeriod2
    label: "EARNED FOR THE PERIOD",
    displayLabel: month
      ? `EARNED FOR THE PERIOD (${month})`
      : "EARNED FOR THE PERIOD",
  });

  if (payItem === "20% Monthly Premium") {
    return [
      [
        { label: "SEQUENCE" },
        ...commonHeaders,
        earnedPeriodHeader(startDate),
        earnedPeriodHeader(endDate),
        { label: "TOTAL EARNED" },
        { label: "20% EARNED AMOUNT" },
        { label: "3%" },
        { label: "NET PAY" },
      ],
      [],
    ];
  }

  const headerMap = {
    [payItem]: [
      { label: "SEQUENCE" },
      ...commonHeaders,
      ...additionalHeader,
      ...deductionHeader,
      { label: "NET PAY" },
    ],
    DEFAULT: [...commonHeaders],
  };

  if (allowanceName in headerMap) {
    return [headerMap[allowanceName], []];
  } else {
    return [[], [], []];
  }
};
